/**
 * `polyglotObject` is an intermediate object used to achieve a late bound
 * translation as a workaround for translated strings done before the language
 * setup.
 *
 * @param {function} spec.translation - A function to return a
 * translation for the current language.
 * @param {string} spec.rawValue - The translatable key.
 * @param {function} [spec.hyphenate] - Function used to hyphenate a string.
 */
export default class PolyglotObject {
	constructor(spec) {
		this._translation = spec.translation;
		this._rawValue = spec.rawValue;
		this._hyphenate = spec.hyphenate || ((text) => text);
	}

	appendToBrush(html) {
		html.render(this._hyphenate(this.translate()));
	}

	localeCompare(otherString) {
		return this.toString().localeCompare(otherString.toString());
	}

	toString() {
		const result = this._translation();
		if (typeof result === "object" && result.constructor === Array) {
			return this._flattenAndJoinStrings(result);
		}
		return result;
	}

	toUpperCase() {
		return this.toString().toUpperCase();
	}

	toLowerCase() {
		return this.toString().toLowerCase();
	}

	translate() {
		return this._translation();
	}

	rawValue() {
		return this._rawValue;
	}

	_flattenAndJoinStrings(anArray) {
		return anArray
			.reduce((resultingValue, currentElement) => {
				if (Array.isArray(currentElement)) {
					return resultingValue.concat(
						this._flattenAndJoinStrings(currentElement),
					);
				}
				return resultingValue.concat(currentElement);
			}, [])
			.join("");
	}
}
